module.exports = __webpack_public_path__ + "a3a7061cd42da4c899d9474499158b42.png";